import React from "react";
import {RichText} from "prismic-reactjs";
import {get} from "lodash";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {useTheme} from "@material-ui/core/styles";
export default function MicrocastSlice(slice) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("600"));

  const bgImage = isMobile
    ? get(slice, "primary.background_image.Mobile.url")
    : get(slice, "primary.background_image.url");

  const bgstyle = {
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center center",
  };

  const renderButton = (buttons) => {
    return buttons.map((el, i) => (
      <a
        key={i}
        className="special-button"
        href={get(el, "cta_url.url")}
        target={get(el, "cta_url.target")}
      >
        <img src={get(el, "button.url")} alt="button" />
      </a>
    ));
  };

  return (
    <div className="microcast-slice" style={bgstyle}>
      <div className="wrapper">
        <div className="content">
          <RichText render={slice.primary.content} />
          <div className="button-container">
            {renderButton(get(slice, "items"))}
          </div>
        </div>
      </div>
    </div>
  );
}
